import { render, staticRenderFns } from "./RelatorioDRE.vue?vue&type=template&id=74faca9c"
import script from "./RelatorioDRE.vue?vue&type=script&lang=js"
export * from "./RelatorioDRE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports